export default "__VITE_ASSET__f331a16a__"